import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Card } from "@mui/material";
import { endpoints } from "../../services/apiurl";
import Input from "../UI/Input/Input";
import PageTitle from "../UI/PageTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import FileUploader from "../FileUploader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddOutlet = () => {
  let history = useHistory();
  const [outlet, setOutlet] = useState({
    outlet_name: "",
    restro_id: "",
    airmenu_id: "",
    position: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelectSuccess = (file) => {
    setSelectedFile(file);
  };

  const handleFileSelectError = ({ error }) => {
    alert(error);
  };

  const [loading, setloading] = useState(false);
  const [rest, setRest] = useState([]);

  const { outlet_name, restro_id, airmenu_id, position } = outlet;
  const onInputChange = (e) => {
    setOutlet({ ...outlet, [e.target.name]: e.target.value });
    //console.log(airmenu_id,"jeet");
  };

  useEffect(() => {
    getRestaurentsDropDown();
  }, []);

  const getRestaurentsDropDown = async () => {
    await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
      setRest(response.data.data);
    });
  };

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append("outlet_name", outlet_name);
    formData.append("restro_id", restro_id);
    formData.append("airmenu_id", airmenu_id);
    formData.append("position", position);

    formData.append("image", selectedFile);
    console.log(formData);
    try {
      const response = await axios.post(endpoints.addOutlet, formData);
      setloading(false);
      history.goBack();
      if (response.data && response.data.status === true) {
        toast.success("Outlet Added Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        // Handle other cases if needed
      }
    } catch (error) {
      console.error("Error during editing Outlet:", error);
      setloading(false);

      toast.error("Error during editing Outlet. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  return (
    <div className="ui main">
      <PageTitle title="Add Outlet" linkurl="" linkTitle="" />

      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <div className="col col-6">
              <label>Main Restaurents </label>
              <select
                name="airmenu_id"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="airmenu_id">Select Restaurents</option>
                {rest.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <Input
              id="name"
              label="Outlet Name"
              type="text"
              name="outlet_name"
              place="Name"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={outlet_name}
              class="col col-6"
            />
          </div>
          <div className="row mt-3">
            <div className="col col-3">
              <label>Outlet Restaurents </label>
              <select
                name="restro_id"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="restro_id">Select Restaurents</option>
                {rest.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <Input
              id="position"
              label="Position"
              type="text"
              name="position"
              place="Position"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={position}
              class="col col-3"
            />
            <div className="col col-6">
              <label>Image</label>
              <FileUploader
                onFileSelectSuccess={handleFileSelectSuccess}
                onFileSelectError={handleFileSelectError}
              />

              {selectedFile && (
                <div>
                  <p>Preview:</p>
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="Selected Logo"
                    height="200px"
                    width="200px"
                    className="mt-3"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
                <ToastContainer />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddOutlet;
